import { assign, get, isEmpty } from "lodash";

const realFetch = require("isomorphic-fetch");

export function fetch(uri, options) {
  let headers = get(options, "headers");
  let token = {
    Authorization: "Bearer " + sessionStorage.getItem("authentication"),
  };
  if (isEmpty(headers)) {
    options.headers = token;
  } else {
    options.headers = assign(headers, token);
  }
  // disable including cookie or else it will fetch casa-rule-ui. we need to migrate casa-rule-ui to keycloak
  // including credentials again for happi release.
  // they are not ready to install new version of apk immediately after release
  options.credentials = sessionStorage.isLegacy === "true" ? "include" : "omit";
  return realFetch(uri, options).then((response) => {
    let version = (JSON.parse(response.headers.get("UI-Versions")) || {})[
      "CASA-DASHBOARD"
    ];
    if (!version) {
      return response;
    }
    let storedVersion = sessionStorage.getItem("version");
    sessionStorage.setItem("version", version);
    if (storedVersion && storedVersion !== version) {
      window.location.reload();
    }
    return response;
  });
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js